import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { scraperOpsAPI } from "components/Apis/scraper"

export const fetchScraperOperations = createAsyncThunk(
    'scraperOperations/fetchScraperOperations',
    async (filters = {}, { rejectWithValue }) => {
        try {
            const response = await scraperOpsAPI.filter(filters);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const scraperOperationsSlice = createSlice({
    name: 'scraperOperations',
    initialState: {
        operations: null,
        loading: false,
        error: null,
        filters: {},
    },
    reducers: {
        setFilters: (state, action) => {
            state.operations = null;
            state.filters = { ...state.filters, ...action.payload };
        },
        clearFilters: (state) => {
            state.operations = null;
            state.filters = {};
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchScraperOperations.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchScraperOperations.fulfilled, (state, action) => {
                state.loading = false;
                state.operations = action.payload; // Store the list of operations
            })
            .addCase(fetchScraperOperations.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Store error message
            });
    },
});

export const { setFilters, clearFilters } = scraperOperationsSlice.actions;
export default scraperOperationsSlice.reducer;